// Phase 5A — Inventory API client.
//
// Dealer-scoped by default; platform_admin may pass ``dealer_id`` on
// list + import. Every response is the raw backend shape; presentation
// lives in the page components.
import { apiFetch } from './client';

export const inventoryApi = {
  list: (params) => apiFetch('/api/inventory', { params }),
  get: (id) => apiFetch(`/api/inventory/${id}`),
  update: (id, patch) =>
    apiFetch(`/api/inventory/${id}`, { method: 'PATCH', body: patch }),
  markSold: (id) =>
    apiFetch(`/api/inventory/${id}/mark-sold`, { method: 'POST', body: {} }),
  markPending: (id) =>
    apiFetch(`/api/inventory/${id}/mark-pending`, { method: 'POST', body: {} }),
  markAvailable: (id) =>
    apiFetch(`/api/inventory/${id}/mark-available`, {
      method: 'POST',
      body: {},
    }),
  importCsv: ({ file, dealerId } = {}) => {
    // FormData — apiFetch preserves Content-Type handling and still
    // attaches the bearer token.
    const form = new FormData();
    form.append('file', file);
    const params = dealerId ? { dealer_id: dealerId } : undefined;
    return apiFetch('/api/inventory/import-csv', {
      method: 'POST',
      body: form,
      params,
    });
  },
};
